import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary gap-20" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "fs-xl lh-1"
}
const _hoisted_7 = {
  key: 1,
  class: "fs-xl lh-1"
}
const _hoisted_8 = {
  key: 0,
  class: "secondary-group d-flex flex-md-row flex-column w-100 pdr-0 pdl-20"
}
const _hoisted_9 = { class: "secondary_group_item d-flex flex-column gap-20" }
const _hoisted_10 = { class: "fw-semibold fs-base" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-pdf d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_13 = { class: "fs-base" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-select-arrow fs-xxs text-primary" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "divider divider_vertical h-100 m-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.isEmployer ? 'Plan form and documents': "Forms & Documents"), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resourceGroup, mainKey) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: mainKey }, [
        _createElementVNode("div", {
          class: "primary-group d-flex justify-content-between align-items-center w-100 plan-modal",
          onClick: ($event: any) => (_ctx.toggleGroup(mainKey))
        }, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(mainKey) + " " + _toDisplayString(_ctx.isLocal ? 'Documents' : ''), 1),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.toggleGroup(mainKey)),
            class: "toggle-btn"
          }, [
            (!_ctx.showGroup[mainKey])
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+"))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
          ], 8, _hoisted_5)
        ], 8, _hoisted_3),
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (_ctx.showGroup[mainKey])
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceGroup, (documents, secondaryKey, secondaryIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: secondaryKey }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h5", _hoisted_10, _toDisplayString(secondaryKey), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVisibleDocuments(documents, mainKey, secondaryKey), (doc, docIndex) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: docIndex,
                            href: doc.file_url,
                            target: "_blank",
                            class: _normalizeClass([{'fade-in': _ctx.isExpanded(mainKey, secondaryKey) && docIndex >= 3, 'fade-out': !_ctx.isExpanded(mainKey, secondaryKey) && docIndex > 3}, "document-item gap-10"])
                          }, [
                            _hoisted_12,
                            _createElementVNode("span", _hoisted_13, _toDisplayString(doc.title), 1)
                          ], 10, _hoisted_11))
                        }), 128)),
                        (documents.length > 3)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.toggleDocs(mainKey, secondaryKey)),
                              class: _normalizeClass(["btn btn-link p-0 justify-content-start", {'bounce-up': _ctx.isExpanded(mainKey, secondaryKey), 'bounce-down': !_ctx.isExpanded(mainKey, secondaryKey)}])
                            }, [
                              _hoisted_15,
                              _createTextVNode(" " + _toDisplayString(_ctx.isExpanded(mainKey, secondaryKey) ? 'View Less' : 'View More'), 1)
                            ], 10, _hoisted_14))
                          : _createCommentVNode("", true)
                      ]),
                      (secondaryIndex < Object.entries(resourceGroup).length - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ], 64))
    }), 128))
  ]))
}